module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_01_american-village-e1d6c6569d05ebd7a6ddfb8f2e083832.jpg";